/**
 * Note: This is a temprorary solution for setting platform for MixPanel
 * events based on user account. This will need modified once we get to
 * where these platforms aren't dependent on role alone.
 */

import MessageBus from '@restore/messagebus';
import Constants from '../../constants/constants';
import { Platform } from '../types';

export const PLATFORMS = {
  THERAPY: 'Therapy',
  WELLNESS: 'Wellness',
  HOME: 'Home',
  CARE: 'Care',
};

const messageBus = new MessageBus();

export const setInitialPlatform = (roleLevel: number) => {
  let platform: Platform;

  switch (roleLevel) {
    case Constants.THERAPIST_ROLE_LEVEL:
      platform = 'Therapy';
      break;
    case Constants.CARE_PARTNER_ROLE_LEVEL:
      platform = 'Wellness';
      break;
    case Constants.PLAYER_ROLE_LEVEL:
      platform = 'Home';
      break;
    case Constants.CNA_ROLE_LEVEL:
      platform = 'Care';
      break;
    default:
      platform = 'Therapy';
      break;
  }

  messageBus.publish('setPlatform', platform);
  return platform;
};
